import { render, staticRenderFns } from "./IconCountry.vue?vue&type=template&id=508f9ec3&"
import script from "./IconCountry.vue?vue&type=script&lang=ts&"
export * from "./IconCountry.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports